// 強み
import { Serializable } from '@/models/core/serializable';
import { GEnum } from '@/constants/enum.defination';
import { Student } from '@/models/student/student';
import i18n from '@/i18n';

// 強み評価
export class StudentGoodPoint implements Serializable<StudentGoodPoint> {
  goodPoint: string;
  giftCourseID: number;
  userGiftCourseID: number;
  evaluatorType: GEnum.EvaluatorType;
  evalStudentInfo: Student;

  deserialize(input: any): StudentGoodPoint {
    this.goodPoint = input.goodPoint;
    this.giftCourseID = input.giftCourseID;
    this.userGiftCourseID = input.userGiftCourseID;
    this.evaluatorType = input.evaluatorType;
    this.evalStudentInfo = new Student().deserialize(input.evaluatorStudent);

    return this;
  }

  get isInternal(): boolean {
    return this.evaluatorType === GEnum.EvaluatorType.Internal;
  }

  get isOutside(): boolean {
    return this.evaluatorType === GEnum.EvaluatorType.Outside;
  }

  get evaluator(): string {
    if (this.isInternal) {
      return `${this.evalStudentInfo.gradeAndSchoolClassName} ${this.evalStudentInfo.fullName}`;
    } else {
      return i18n.t('OTHER').toString();
    }
  }
}

// AIGROW2-533 強み評価を生徒単位でまとめて表示する
export class GoodPointUnitByStudent {
  goodPoints: string[] = [];
  evaluatorType: GEnum.EvaluatorType;
  evalStudentInfo: Student;

  get isInternal(): boolean {
    return this.evaluatorType === GEnum.EvaluatorType.Internal;
  }

  get isOutside(): boolean {
    return this.evaluatorType === GEnum.EvaluatorType.Outside;
  }

  get evaluator(): string {
    if (this.isInternal) {
      return `${this.evalStudentInfo.gradeAndSchoolClassName} ${this.evalStudentInfo.fullName}`;
    } else {
      return i18n.t('OTHER').toString();
    }
  }
}